import styled, { css } from 'styled-components';

import { HOME } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Root = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 0 8px;
`;

export const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: ${HOME.t600};
`;

/** The colour swatch — a solid dot, or a dashed ring for the dashed series. The
 *  hue is a token value handed in by the section (never a literal here). */
export const Dot = styled.i<{ $dashed: boolean; $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  ${(p) =>
    p.$dashed
      ? css`
          background: transparent;
          border: 1px dashed ${p.$color};
        `
      : css`
          background: ${p.$color};
        `}
`;

export const Name = styled(Text)`
  display: inline;
`;
